module.exports = __webpack_public_path__ + "img/menu2.64e2fbce.png";